export default "__VITE_ASSET__YaHUaXwk__"